export let ScanFailureReason = /*#__PURE__*/function (ScanFailureReason) {
  ScanFailureReason["DOMAIN_UNREACHABLE"] = "DOMAIN_UNREACHABLE";
  ScanFailureReason["PAGE_SERVER_ERROR"] = "PAGE_SERVER_ERROR";
  ScanFailureReason["PAGE_ACCESS_DENIED"] = "PAGE_ACCESS_DENIED";
  ScanFailureReason["PAGE_LOAD_TIMEOUT"] = "PAGE_LOAD_TIMEOUT";
  ScanFailureReason["SITE_DELETED"] = "SITE_DELETED";
  ScanFailureReason["NO_PAGES_FOUND"] = "NO_PAGES_FOUND";
  ScanFailureReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
  ScanFailureReason["SCAN_TIMEOUT"] = "SCAN_TIMEOUT";
  return ScanFailureReason;
}({});
//# sourceMappingURL=scan-failure-reason.js.map